import { TemplateTimeslotsChannelPayload } from "./templateTimeslotsChannel.reducer"

export enum Types {
  CONNECT = "TEMPLATETIMESLOTSCHANNEL_CONNECT",
  CONNECTION_SUCCESS = "TEMPLATETIMESLOTSCHANNEL_CONNECTION_SUCCESS",
  CONNECTION_FAILED = "TEMPLATETIMESLOTSCHANNEL_CONNECTION_FAILED",
  DISCONNECT = "TEMPLATETIMESLOTSCHANNEL_DISCONNECT",
  DISCONNECT_SUCCESS = "TEMPLATETIMESLOTSCHANNEL_DISCONNECT_SUCCESS",
  DISCONNECT_FAILED = "TEMPLATETIMESLOTSCHANNEL_DISCONNECT_FAILED",
}

export type Action =
  | ConnectTemplateTimeslotsChannelAction
  | ConnectionTemplateTimeslotsChannelSuccessAction
  | ConnectionTemplateTimeslotsChannelFailAction
  | DisconnectTemplateTimeslotsChannelAction
  | DisconnectTemplateTimeslotsChannelSuccessAction
  | DisconnectTemplateTimeslotsChannelFailAction

export type ConnectTemplateTimeslotsChannelAction = {
  payload: TemplateTimeslotsChannelPayload
  type: Types.CONNECT
}

export type ConnectionTemplateTimeslotsChannelSuccessAction = {
  type: Types.CONNECTION_SUCCESS
}

export type ConnectionTemplateTimeslotsChannelFailAction = {
  payload: { errors: object }
  type: Types.CONNECTION_FAILED
}

export type DisconnectTemplateTimeslotsChannelAction = {
  type: Types.DISCONNECT
}

export type DisconnectTemplateTimeslotsChannelSuccessAction = {
  type: Types.DISCONNECT_SUCCESS
}

export type DisconnectTemplateTimeslotsChannelFailAction = {
  payload: { errors: object }
  type: Types.DISCONNECT_FAILED
}

export function connectTemplateTimeslotsChannel(
  payload: TemplateTimeslotsChannelPayload,
): ConnectTemplateTimeslotsChannelAction {
  return {
    payload,
    type: Types.CONNECT,
  }
}

export function connectionTemplateTimeslotsChannelSuccess(): ConnectionTemplateTimeslotsChannelSuccessAction {
  return {
    type: Types.CONNECTION_SUCCESS,
  }
}

export function connectionTemplateTimeslotsChannelFail(errors: object): ConnectionTemplateTimeslotsChannelFailAction {
  return {
    payload: { errors },
    type: Types.CONNECTION_FAILED,
  }
}

export function disconnectTemplateTimeslotsChannel(): DisconnectTemplateTimeslotsChannelAction {
  return {
    type: Types.DISCONNECT,
  }
}

export function disconnectTemplateTimeslotsChannelSuccess(): DisconnectTemplateTimeslotsChannelSuccessAction {
  return {
    type: Types.DISCONNECT_SUCCESS,
  }
}

export function disconnectTemplateTimeslotsChannelFail(errors: object): DisconnectTemplateTimeslotsChannelFailAction {
  return {
    payload: { errors },
    type: Types.DISCONNECT_FAILED,
  }
}
